import PriceBar from './PriceBarMobile';
export default PriceBar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBarSub/PriceBarMobile/index.js
// module id = 2223
// module chunks = 8